<template>
  <div class="slide-content">
    <div class="resize-body">
      <div class="resize-content" :style="`transform: translate(-50%,-50%) scale(${scaling})`">
        <div class="title-content">
          <img src="../../../assets/image/kjqg/index/kcjs/kcjs-kcxf.png" class="kcxf-title" alt="">
        </div>
        <div class="kcxf-list swiper-no-swiping">

          <div class="kcxf-item" @click="toList(2,0)">
            聚焦科研“领航者”，他们深耕关键领域数十载，以深厚学识突破技术壁垒，
            从对海探测到芯片研发，用执着与智慧，引领行业跨越未知，为科创筑牢“顶梁
            柱”，撑起国家科技发展的脊梁。
          </div>
          <div class="kcxf-item" @click="toList(2,1)">
            听青年科技“新声”！他们带着新锐视角、无畏勇气，在人工智能、生物医
            药等前沿赛道冲刺。用朝气与创新思维，打破传统科研边界，书写属于 Z 世代的
            科创未来，让青春成为驱动创新的“燃料”。
          </div>
          <div class="kcxf-item" @click="toList(2,2)">
            她们以柔肩扛起科创使命，在实验室里破译生命密码，在田野间守护生态平
            衡，在深耕分子领域改变世界，用女性独有的韧性与细腻，点亮科研星空，证明
            “她力量”能撑起科创“半边天”。
          </div>
          <div class="kcxf-item" @click="toList(2,3)">
            扎根各领域的科技人，有人深耕基层让农业自动化落地，有人攻坚环保为冶
            金“排毒”。从守护食品安全，到治愈地球生态，他们以数十年坚守、一次次创
            新，用实干诠释“最美”，绘就科创群像里最温暖的底色。
          </div>
          <div class="kcxf-more" @click="toMoreList(2)">查看更多</div>
        </div>
        <div class="title-content">
          <img src="../../../assets/image/kjqg/index/kcjs/kcjs-kjxj.png" class="zcqd-title" alt="">
        </div>
        <div class="kjxj-info">
          <swiper :options="kjxjSwiper" v-if="gxList.length > 0">
            <swiperSlide v-for="(item,ind) in gxList" :key="ind">
              <div class="kjxj-item">
                <div class="scale-item" :style="{ backgroundImage: item.cover ? `url(${item.cover})` : '',}">
                  <div class="xj-info">
                    <!-- <div class="xj-title">张三丰</div>
                    <div class="xj-subtitle">物理学专业</div> -->
                    <div class="xj-subtitle" v-for="(ele,index) in item.abstract.split(',')" :key="index">{{ele}}</div>
                  </div>
                </div>
              </div>
            </swiperSlide>

          </swiper>
          <div class="swiper-button-next kjxj"></div>
          <div class="swiper-button-prev kjxj"></div>
          <div class="swiper-pagination kjxj"></div>
        </div>
        <div class="more" @click="toMoreList(3)">查看更多</div>
      </div>
    </div>
    <videoModal :videoShow="videoShow" :videoInfo="videoInfo" :videoTitle="videoInfo.title" @closeModal="videoShow = false"></videoModal>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import videoModal from "./video-modal.vue";
import services from "../../../assets/js/services";
import { mapActions } from "vuex";
export default {
  props: ["scaling"],
  components: {
    swiper, swiperSlide, videoModal
  },
  created() {
    this.getgxList()
  },
  data() {
    let self = this
    return {
      specialId: services.KJQG_SPECIAL_ID,
      school_code: localStorage.getItem("schoolCode"),
      kjxjSwiper: {
        slidesPerView: 5,
        // spaceBetween: 35,
        centeredSlides: true,
        centeredSlidesBounds: true,
        loop: true,
        slideToClickedSlide: true,
        autoplayDisableOnInteraction: false,
        autoplay: {
          delay: 5000,
          // pauseOnMouseEnter: true,
          disableOnInteraction: false
        },
        navigation: {
          // 前进后退按钮 ,不同版本配置方式不同
          nextEl: `.swiper-button-next.kjxj`,
          prevEl: `.swiper-button-prev.kjxj`,
        },
        pagination: {
          el: `.swiper-pagination.kjxj`,
        },
        on: {
          click: function (e) {
            // console.log(this, this.clickedIndex,this.realIndex);
            self.showVideo(self.gxList[this.realIndex])
          }
        }
      },
      gxList: [],
      videoShow: false,
      videoInfo: {}
    }
  },
  methods: {
    ...mapActions(["goAppsDetailsBeforeLogin"]),
    async getgxList() {
      let res = await services.getAreaSzztkLists({
        page: 1,
        length: 8,
        count: 0,
        school_code: this.school_code,
        special_id: this.specialId,
        kind: "1",
        is_video: 1,
        column_name: "科技小匠",
        order_by: "asc"
      })
      if (res.code == "0000" && res.data.items) {
        this.gxList = res.data.items
      }
    },
    showVideo(item) {
      // if (item.is_open_url == 2) {
      //   this.goAppsDetailsBeforeLogin().then(() => {
      //     window.open(`${item.source_url}`, "_blank");
      //   })

      // } else {
      if (item.tencent_vod_file_id && item.tencent_vod_app_id) {
        this.videoInfo = item,
          this.videoShow = true
      } else {
        this.goAppsDetailsBeforeLogin().then(() => {
          let routeUrl = this.$router.resolve({
            path: `/${this.school_code}/kjqg/detail`,
            query: {
              id: item.id,
              column_id: item.column_id,
              columnPath: "kcjsgm",
            },
          });
          window.open(routeUrl.href, "_blank");

        })

      }
      // }


    },
    toMoreList(ind) {
      this.goAppsDetailsBeforeLogin().then(() => {
        let routeUrl = this.$router.resolve({
          path: `/${this.school_code}/kjqg/kcjsgm?ind=${ind}`,
        });
        window.open(routeUrl.href, "_blank");
      });

    },
    toList(ind, cateInd) {
      this.goAppsDetailsBeforeLogin().then(() => {
        let routeUrl = this.$router.resolve({
          path: `/${this.school_code}/kjqg/kcjsgm?ind=${ind}&cateInd=${cateInd}`,
        });
        window.open(routeUrl.href, "_blank");
      });
    }
  }
}
</script>

<style lang="less" scoped>
.slide-content {
  padding-top: 5.16vw;

  background-size: cover;
  background-position: center;
  height: 100%;
  position: relative;
  .resize-body {
    position: relative;
    width: 100%;
    height: 100%;
    .resize-content {
      // height: 100%;
      width: 1920px;
      transform-origin: center center;
      height: 981px;
      position: absolute;
      top: 50%;
      left: 50%;
      // transform: translateX(-50%);
      .title-content {
        // margin: 0 auto;
        text-align: center;
        .kcxf-title {
          max-width: 812px;
          margin-top: 30px;
        }
        .zcqd-title {
          max-width: 812px;
        }
      }
      .kcxf-list {
        width: 1410px;
        margin: 15px auto 30px;
        display: flex;
        align-items: center;
        .kcxf-item {
          background-size: cover;
          background-position: center;
          writing-mode: vertical-rl;
          padding: 73px 40px 45px;
          letter-spacing: 1px;
          font-weight: 400;
          font-size: 15px;
          color: #ffffff;
          line-height: 28px;
          cursor: pointer;
          &:nth-child(1) {
            width: 320px;
            height: 403px;
            background-image: url("../../../assets/image/kjqg/index/kcjs/kcxf-1.png");
          }
          &:nth-child(2) {
            width: 320px;
            height: 403px;
            background-image: url("../../../assets/image/kjqg/index/kcjs/kcxf-2.png");
            margin-left: 23px;
          }
          &:nth-child(3) {
            width: 320px;
            height: 403px;
            background-image: url("../../../assets/image/kjqg/index/kcjs/kcxf-3.png");
            margin-left: 23px;
          }
          &:nth-child(4) {
            width: 320px;
            height: 403px;
            background-image: url("../../../assets/image/kjqg/index/kcjs/kcxf-4.png");
            margin-left: 23px;
          }
        }
        .kcxf-more {
          width: 47px;
          height: 148px;
          background-image: url("../../../assets/image/kjqg/index/kcjs/kcxf-more.png");
          background-size: cover;
          background-position: center;
          writing-mode: vertical-lr;
          font-weight: 400;
          font-size: 16px;
          color: #0c6aef;
          line-height: 47px;
          text-align: center;
          cursor: pointer;
          margin-left: 23px;
        }
      }
      .kjxj-info {
        width: 1460px;
        height: 250px;
        position: relative;
        padding: 0 30px;
        margin: 22px auto 0;
        overflow: hidden;
        .swiper-button-next.kjxj {
          width: 50px;
          height: 50px;
          background-image: url("../../../assets/image/kjqg/index/kcjs/kcjs-swiper-next-btn.png");
          background-size: cover;
          top: 64px;
          margin: 0;
          opacity: 1;
          &:hover {
            background-image: url("../../../assets/image/kjqg/index/kcjs/kcjs-swiper-next-btn-hover.png");
          }
        }
        .swiper-button-prev.kjxj {
          width: 50px;
          height: 50px;
          background-image: url("../../../assets/image/kjqg/index/kcjs/kcjs-swiper-prve-btn.png");
          background-size: cover;
          top: 64px;

          margin: 0;
          opacity: 1;
          &:hover {
            background-image: url("../../../assets/image/kjqg/index/kcjs/kcjs-swiper-prve-btn-hover.png");
          }
        }
        .swiper-container {
          overflow: unset;
          height: 250px;

          .swiper-wrapper {
            .swiper-slide {
              height: 180px;
              position: relative;

              &.swiper-slide-active {
                .kjxj-item {
                  top: 0;
                  left: 50%;
                  transform: translateX(-50%);
                  width: 300px;
                  .scale-item {
                    width: 300px;
                    height: 225px;
                    .xj-info {
                      display: block;
                    }
                  }
                }
              }
              &.swiper-slide-prev {
                .kjxj-item {
                  left: -5px;
                }
              }
              &.swiper-slide-next {
                .kjxj-item {
                  right: -5px;
                }
              }
              &.swiper-slide-next + .swiper-slide {
                .kjxj-item {
                  right: 0;
                }
              }
              &.swiper-slide-next + .swiper-slide + .swiper-slide {
                .kjxj-item {
                  right: 0;
                }
              }
              .kjxj-item {
                width: 240px;
                height: 180px;
                position: absolute;
                &:hover {
                  .scale-item {
                    width: 300px;
                    height: 225px;
                    .xj-info {
                      display: block;
                    }
                  }
                }
                .scale-item {
                  width: 240px;
                  height: 180px;
                  transition: all 0.3s;
                  position: absolute;
                  top: 0;
                  left: 50%;
                  transform: translateX(-50%);
                  display: flex;
                  flex-direction: column;
                  justify-content: flex-end;
                  background-size: cover;
                  background-position: center;
                  cursor: pointer;
                  .xj-info {
                    width: 100%;
                    // height: 120px;
                    background: linear-gradient(
                      0deg,
                      #1e5bf1 0%,
                      rgba(255, 255, 255, 0) 100%
                    );
                    padding: 24px 17px 10px;
                    position: absolute;
                    bottom: 0;
                    display: none;
                    .xj-title {
                      font-weight: bold;
                      font-size: 18px;
                      color: #ffffff;
                      margin-bottom: 8px;
                    }
                    .xj-subtitle {
                      font-weight: 400;
                      font-size: 14px;
                      color: #ffffff;
                      margin-bottom: 4px;
                      &:first-child {
                        font-weight: bold;
                        font-size: 18px;
                        color: #ffffff;
                        margin-bottom: 8px;
                      }
                    }
                  }
                }
              }
            }
          }
        }
        .swiper-pagination {
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          /deep/.swiper-pagination-bullet {
            width: 8px;
            height: 8px;
            background: #87abff;
            border-radius: 50%;
            border: 1px solid #ffffff;
            margin: 4px;
            opacity: 1;
            &.swiper-pagination-bullet-active {
              width: 24px;
              height: 8px;
              background: linear-gradient(90deg, #047bfd 0%, #1952da 100%);
              border-radius: 3px;
            }
          }
        }
      }

      .more {
        width: 148px;
        height: 47px;
        line-height: 47px;
        background-image: url("../../../assets/image/kjqg/index/xskj/more.png");
        background-size: cover;
        font-weight: 400;
        font-size: 16px;
        color: #0c6aef;
        text-align: center;
        margin: 25px auto 0;
        cursor: pointer;
      }
    }
  }
}
</style>